import { Field, ID, ObjectType, registerEnumType } from 'type-graphql'
import {
  Column,
  CreateDateColumn,
  Entity,
  Index,
  ManyToOne,
  PrimaryGeneratedColumn,
  RelationId,
  UpdateDateColumn,
  VersionColumn
} from 'typeorm'

import { Role, User } from '@things-factory/auth-base'
import { Domain, ScalarObject } from '@things-factory/shell'

@Entity()
@Index('ix_data_archive_0', (dataArchive: DataArchive) => [dataArchive.id], { unique: true })
@ObjectType({
  description:
    'Represents a data archive record for storing historical data exports. This entity tracks archive requests, download status, and provides access to historical data files.'
})
export class DataArchive {
  @PrimaryGeneratedColumn('uuid')
  @Field(type => ID, { description: 'Unique identifier for the data archive.' })
  readonly id: string

  @ManyToOne(type => Domain)
  @Field(type => Domain)
  domain?: Domain

  @RelationId((dataArchive: DataArchive) => dataArchive.domain)
  domainId?: string

  @Column({ nullable: true })
  @Field({ nullable: true })
  type?: 'manual' | 'automatic' | string

  @Column('simple-json', { nullable: true })
  @Field(type => ScalarObject, {
    nullable: true,
    description: 'Parameters used for the archive request including query filters and export options.'
  })
  requestParams?: { [key: string]: any }

  @Column({ nullable: true })
  @Field({ nullable: true, description: 'Presigned URL for downloading the archived data file.' })
  downloadUrl?: string

  @Column({ nullable: true })
  @Field({ nullable: true, description: 'Current status of the archive request (pending, done, error).' })
  status?: string

  @CreateDateColumn()
  @Field({ nullable: true })
  createdAt?: Date

  @UpdateDateColumn()
  @Field({ nullable: true })
  updatedAt?: Date

  @ManyToOne(type => User, { nullable: true })
  @Field(type => User, { nullable: true })
  creator?: User

  @RelationId((dataArchive: DataArchive) => dataArchive.creator)
  creatorId?: string

  @ManyToOne(type => User, { nullable: true })
  @Field(type => User, { nullable: true })
  updater?: User

  @RelationId((dataArchive: DataArchive) => dataArchive.updater)
  updaterId?: string
}
